import React from 'react'
import Iframe from 'react-iframe'
import { withRouter } from 'react-router'

import { Label } from 'components/atoms/Texts/TxtLabel';
import { HeadContainer, IframeWrapper, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles'

const { REPORT_URL } = process.env

const BargePerformance = ({ match: { params: { loadingId } } }) => {
  function getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 384}px` : `${h - 300}px`
  }

  return (
    <RoundedWrapper>
      <MainWrapper>
        <HeadContainer>
          <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
            Barge Performance
          </Label>
        </HeadContainer>
        <LevelRowContainer isTop>
          <IframeWrapper>
            <Iframe
              url={`${REPORT_URL}BARGE_PERFORMANCE&BARGE_LOADING_ID=${loadingId}&rs:Command=Render&rc:Parameters=TRUE`}
              width="100%"
              height={getIframeHeight()}
              display="initial"
              position="relative"
              frameBorder="0" />
          </IframeWrapper>
        </LevelRowContainer>
      </MainWrapper>
    </RoundedWrapper>
  )
}

export default withRouter(BargePerformance)
